<template>
  <div v-if="User">
    <!-- <div
      class="modal fade adminprofile-editmodal"
      id="editProfileModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body"> -->
    <div class="edit-profile-head">
      <h3>Edit Profile</h3>
      <p data-dismiss="modal" aria-label="Close">
        <v-icon color="#333333" size="25px">mdi-close</v-icon>
      </p>
    </div>
    <v-row class="mt-8 px-10">
      <v-col md="4" sm="4" cols="12">
        <div class="profile-pic-hld">
          <div class="profile-pic-inner">
            <img v-if="User.ProfileImageURL" :src="User.ProfileImageURL" alt="DG" />
            <img v-else src="../assets/Images/avatar.jpg" alt="DG" />
          </div>
          <div class="profile-upload-sec">
            <v-icon dark icon color="#ffffff">mdi-pencil-outline</v-icon>
          </div>
        </div>
        <div class="admin-edit-social-links"></div>
      </v-col>
      <v-col md="8" sm="8" cols="12">
        <div class="edit-profile-prof-details">
          <v-row>
            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>First Name</label>
                <div class="position-relative">
                  <input type="text" v-model="User.FirstName" />
                  <div class="edit-bio-button edit-button-names">
                    <v-icon dark icon color="#959595"
                      >mdi-pencil-outline</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>Last Name</label>
                <div class="position-relative">
                  <input type="text" v-model="User.LastName" />
                  <div class="edit-bio-button edit-button-names">
                    <v-icon dark icon color="#959595"
                      >mdi-pencil-outline</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>Email</label>
                <div class="position-relative" style="opacity:0.6">
                  <input type="email" v-model="User.Email" readonly />
                </div>
              </div>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>Mobile</label>
                <div class="position-relative">
                  <input type="text" v-model="User.Phone" />
                  <div class="edit-bio-button edit-button-names">
                    <v-icon dark icon color="#959595"
                      >mdi-pencil-outline</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>Company</label>
                <div class="position-relative">
                  <input type="text" v-model="User.Company" />
                  <div class="edit-bio-button edit-button-names">
                    <v-icon dark icon color="#959595"
                      >mdi-pencil-outline</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6" sm="6" cols="12">
              <div class="name-edit-wrap">
                <label>Title</label>
                <div class="position-relative">
                  <input type="text" v-model="User.Designation" />
                  <div class="edit-bio-button edit-button-names">
                    <v-icon dark icon color="#959595"
                      >mdi-pencil-outline</v-icon
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="edit-profile-bio-wrap">
            <label>Mini Bio</label>
            <div class="edit-profile-bio-inner">
              <textarea cols="20" rows="10" v-model="User.Profile"></textarea>
              <div class="edit-bio-button">
                <v-icon dark icon color="#ffffff">mdi-pencil-outline</v-icon>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <div class="save-edit-profile">
      <v-btn
        outlined
        color="#333"
        width="120px"
        class="mr-3"
        data-dismiss="modal"
        >Cancel</v-btn
      >
      <v-btn dark color="#1a73e8" width="120px">Save</v-btn>
    </div>
    <!-- </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
// import APIs from "@/components/APIInit";
// import db from "../components/firebaseInit";
// import firebase from "firebase";
// import store from "../store";
// import router from "../router";
// import jQuery from "jquery";
// let $ = jQuery;
// import Vue from "vue";
// import VueMoment from "vue-moment";
// import moment from "moment-timezone";
// import axios from "axios";
// import { bus } from "@/main";
// import jwt_decode from "jwt-decode";

export default {
  data() {
    return {
      uid: "",
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      ShowCreateEventButton: false,
      searchText: "",
      filterDateFrom: "",
      filterDateTo: "",
      filterStatus: "",
      tab: null,
      switch1: true,
      radioGroup: 1,
      User: null,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  mounted() {
    this.User = this.getSessionUserProfile();
  },
  methods: {
    SaveUserProfile() {
      //
    },
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>